import { newAxiosIns } from '@/libs/axios'

export default function apiGetWhatsAppList() {
  return newAxiosIns.get('komchat-api/api/v1/agent/available_phone')
}
